import { useState } from 'react';
import { ModalParams } from 'hooks/useModal';
import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { CartItemList } from '../CartItemList';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';
import RadioButton from 'components/RadioButton';
import { GraniteLabel } from 'components/V2/Label/GraniteLabel';
import { observer } from 'mobx-react-lite';

type ShippingAssignmentMethod = 'checkout' | 'manual';

const OPTIONS: { value: ShippingAssignmentMethod; label: string }[] = [
  {
    value: 'checkout',
    label: 'Choose a different shipping address during checkout',
  },
  {
    value: 'manual',
    label: 'Manually add this item to locations already in my cart',
  },
];

export interface ReviewOrderModalProps extends ModalParams {
  onConfirmation: (method: ShippingAssignmentMethod) => void;
}

export const ShippingAssignmentModal = observer(
  ({ isOpen, close, onConfirmation }: ReviewOrderModalProps) => {
    const cart = useCartContext();
    const [value, setValue] = useState(OPTIONS[0].value);

    const items = cart.unassignedPrimaryMobilityItems;

    return (
      <Modal
        isVisible={isOpen}
        close={close}
        className="vertical-scrollbar max-h-[90vh] max-w-[624px] overflow-y-auto "
      >
        <div className="flex flex-col gap-2 rounded-t-lg bg-background-base-surface-3 px-8 py-6">
          <h1 className="text-2xl leading-8 text-content-base-default">
            Shipping address needed
          </h1>
          <p className="font-semibold text-content-base-subdued">
            To proceed with checkout, the item below needs to be associated with
            a shipping address. You can ship this item to a brand new address or
            ship it to any location already in your cart.
          </p>
        </div>
        <div className="flex flex-col gap-12 p-8">
          <div className="flex flex-col gap-8">
            <div>
              <div className="mb-2 font-semibold">
                Pending assignment ({items.length})
              </div>
              <div className="vertical-scrollbar flex max-h-[calc(30vh)] min-h-[107px] flex-grow flex-col overflow-y-auto overflow-x-hidden !scrollbar-track-transparent scrollbar-thumb-stroke-base-subdued">
                <CartItemList items={items} className="!gap-2" />
              </div>
            </div>
            <div>
              <GraniteLabel
                label="How do you want to proceed?"
                className="col-start-1"
              >
                <RadioButton
                  options={OPTIONS}
                  selectedValue={value}
                  onChange={(val: string) =>
                    setValue(val as ShippingAssignmentMethod)
                  }
                  className="text-base"
                />
              </GraniteLabel>
            </div>
          </div>
          <div className="flex flex-col gap-5 md:flex-row">
            <GraniteButton size="large" variant="secondary" onClick={close}>
              Cancel
            </GraniteButton>
            <GraniteButton size="large" onClick={() => onConfirmation(value)}>
              Continue
            </GraniteButton>
          </div>
        </div>
      </Modal>
    );
  },
);
